import React, {useState, useEffect, useContext} from 'react';
import {
  Box,
  Toolbar,
  Typography,
  Container,
  Paper,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  IconButton,
  CssBaseline,
} from '@mui/material';
import {Context as AuthContext} from '../../contexts/AuthContext';
import HomeDrawer from '../../components/Common/HomeDrawer';
import {Link, useNavigate, useLocation} from 'react-router-dom';

const headerStyle = {
  color: '#9d9db0',
  fontSize: 18,
  fontWeight: 700,
  letterSpacing: '1.6px',
  lineHeight: '24px',
  textTransform: 'uppercase',
  alignSelf: 'flex-start',
};

const NotificationMenu = ({}) => {
  const {state: route} = useLocation();
  const {
    state: {uid, client},
  } = useContext(AuthContext);

  const [index, setIndex] = useState(route && route.index ? route.index : 5);

  const weekly = client && client.weeklyUpdates ? client.weeklyUpdates : [];
  const atRisk = client && client.atRiskUpdates ? client.atRiskUpdates : [];

  const users = [
    {name: 'Charlie Caswell', email: 'ccaswell@finsiteful.com', active: true},
    {name: 'Axel Fries', email: 'afries@finsiteful.com', active: true},
  ];

  return (
    <Box sx={{display: 'flex', minWidth: '1200px'}}>
      <CssBaseline />
      <HomeDrawer index={index} setIndex={setIndex} product="notifications" />
      <Box
        component="main"
        sx={{
          backgroundColor: '#fff',
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          padding: '60px',
        }}>
        <Container maxWidth="lg" sx={{mt: 4, mb: 4}}>
          <Grid container spacing={3}>
            <Card>
              <Typography
                component="h2"
                variant="h6"
                color="primary"
                gutterBottom
                style={headerStyle}>
                Settings
              </Typography>
              <Typography>Weekly updates on at all users.</Typography>
              <Typography>Weekly updates on at risk users.</Typography>
              <Typography>Live updates of at risk users.</Typography>
            </Card>
            <Notification
              users={weekly}
              header="Weekly Update"
              subheader="Receive a snapshot of you dashboard in your email every Monday"
            />
            <Notification
              users={atRisk}
              header="At-Risk Updates"
              subheader="Receive an email each time an at-risk student requests help."
            />
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

const Card = ({children}) => {
  return (
    <Grid item xs={12} md={12} lg={12}>
      <Paper
        sx={[
          {
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            padding: '48px 64px',
            borderRadius: '12px',
            alignItems: 'center',
          },
        ]}
        elevation={24}>
        {children}
      </Paper>
    </Grid>
  );
};

const Notification = ({users, header, subheader, onAdd, onDelete}) => {
  return (
    <Grid item xs={12} md={12} lg={12}>
      <Paper
        sx={[
          {
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            padding: '48px 64px',
            borderRadius: '12px',
            alignItems: 'center',
          },
        ]}
        elevation={24}>
        <Typography
          component="h2"
          variant="h6"
          color="primary"
          gutterBottom
          style={headerStyle}>
          {header}
        </Typography>
        <Typography
          color="text.secondary"
          sx={{flex: 1}}
          style={{alignSelf: 'flex-start'}}>
          {subheader}
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Name</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Email</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Remove</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.slice(0, 10).map(row => {
              return (
                <TableRow key={row.email}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>
                    <Button
                      disabled={false}
                      onPress={() =>
                        console.log('Sent help for student: ', row.email)
                      }>
                      X
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Button
          sx={{alignSelf: 'flex-start'}}
          disabled={false}
          onPress={() => console.log('Sent help for student: ')}>
          + Add another
        </Button>
      </Paper>
    </Grid>
  );
};

export default NotificationMenu;
